import { api, buildQueryParams, URLs } from '@/libs/api'
import type {
  ApiResponse,
  Companies,
  CompaniesListData,
  CompaniesListParam,
  CompanyPayload,
  CursorPaginatedResponse,
} from '@/libs/interfaces'
import { IS_MOCK_MODE } from '@/libs/mocks/config'
import { companiesApiMock } from '@/libs/mocks/handlers/companies'

const companiesApiReal = {
  getByID: async (params: { orgID: string; companyOrgNumber: string }): Promise<Companies> => {
    return await api
      .get<ApiResponse<Companies>>(URLs.Companies.byID(params.orgID, params.companyOrgNumber))
      .then((response) => response.data.data)
  },
  update: async (payload: Partial<Companies>): Promise<Companies> => {
    const { orgID = '', companyOrgNumber = '', ...patchData } = payload
    return await api
      .patch<ApiResponse<Companies>>(URLs.Companies.byID(orgID, companyOrgNumber), patchData)
      .then((response) => response.data.data)
  },
  create: async (payload: CompanyPayload): Promise<Companies> => {
    return api
      .post<ApiResponse<Companies>>(URLs.Companies.create(payload.orgID || ''), payload)
      .then((response) => response.data.data)
  },
  list: async (params: CompaniesListParam): Promise<Companies[]> => {
    const { orgID, ...queryParams } = params
    const query = buildQueryParams(queryParams)
    return await api
      .get<ApiResponse<CompaniesListData>>(URLs.Companies.list(orgID, query))
      .then((response) => response.data?.data.companies || [])
  },
  listCursor: async (params: CompaniesListParam): Promise<CursorPaginatedResponse<Companies>> => {
    const { orgID, ...queryParams } = params
    const query = buildQueryParams(queryParams)
    const response = await api
      .get<ApiResponse<CompaniesListData>>(URLs.Companies.list(orgID, query))
      .then((response) => response?.data?.data)

    return {
      data: response?.companies,
      pageInfo: {
        first: response.first,
        prev: response.prev,
        cursor: response.cursor,
        next: response.next,
        last: response.last,
      },
    }
  },
}

export const companiesApi: typeof companiesApiReal = IS_MOCK_MODE
  ? companiesApiMock
  : companiesApiReal
